/**
 * Utility functions for calculating and working with UDP network crowding metrics
 */

export const maxCrowdedness: number = 3500;

/**
 * Calculate crowding score based on average StC and CtS values
 * @param avgStc Average server-to-client packets
 * @param avgCts Average client-to-server packets
 * @param maxCrowdedness Maximum expected crowding value
 * @returns Crowding score between 0 and 1
 */
export function getCrowdednessScore(avgStc: number, avgCts: number, maxCrowdedness: number): number {
  return Math.min(1, Math.round(((avgStc + avgCts) / maxCrowdedness) * 100) / 100);
}

/**
 * Get crowding tier name based on score
 * @param score Crowding score between 0 and 1
 * @returns Tier name
 */
export function getCrowdingTier(score: number): string {
  if (score >= 0.8) {
    return "Fondo";
  }
  if (score >= 0.6) {
    return "Packed";
  }
  if (score >= 0.4) {
    return "Crowded";
  }
  if (score >= 0.2) {
    return "Company";
  }
  return "Solo";
}

/**
 * Get crowding tier CSS class name
 * @param tier Crowding tier name
 * @returns CSS class name
 */
export function getCrowdingCssClass(tier: string): string {
  return tier.toLowerCase();
}
